import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faHashtag, faPercentage, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        municipio: [],
        departamentosVisita: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.municipio;
        state[e.target.name] = e.target.value;
        this.setState({ municipio: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const nombre = document.getElementById('nombre').value;
        const id_municipio = document.getElementById('id_municipio').value;
        const abreviatura = document.getElementById('abreviatura').value;
        const id_departamento = document.getElementById('ID_DEPARTAMENTO').value;
        const tarifa_interventoria = document.getElementById('tarifa_interventoria').value;
        const concepto_calculo = document.getElementById('CONCEPTO_CALCULO').value;
        const costo_ingenieria = document.getElementById('costo_ingenieria').value;
        const costo_admin_obra = document.getElementById('costo_admin_obra').value;
        const costo_inspector = document.getElementById('costo_inspector').value;
        const costo_interventoria = document.getElementById('costo_interventoria').value;
        const costo_financiero = document.getElementById('costo_financiero').value;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!abreviatura) { errores.push("error_abreviatura"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!tarifa_interventoria) { errores.push("error_tarifa_interventoria"); }
        if (!concepto_calculo) { errores.push("error_concepto_calculo"); }
        if (!costo_ingenieria) { errores.push("error_costo_ingenieria"); }
        if (!costo_admin_obra) { errores.push("error_costo_admin_obra"); }
        if (!costo_inspector) { errores.push("error_costo_inspector"); }
        if (!costo_interventoria) { errores.push("error_costo_interventoria"); }
        if (!costo_financiero) { errores.push("error_costo_financiero"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("municipios_visitas/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                Swal.close();
                Swal.fire(
                    'Municipios Visita!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterMunicipiosVisita");
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("municipios_visitas/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, municipio: datosRespuesta.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, departamentosVisita: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, municipio, departamentosVisita } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR MUNICIPIO VISITA</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="ID_DEPARTAMENTO">Departamento</label>
                                                    <select name="ID_DEPARTAMENTO"
                                                        id="ID_DEPARTAMENTO"
                                                        value={municipio.ID_DEPARTAMENTO}
                                                        options={municipio.ID_DEPARTAMENTO}
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentosVisita.map((itemDepartamentosVisita) => (
                                                                <option key={itemDepartamentosVisita.ID_DEPARTAMENTO} value={itemDepartamentosVisita.ID_DEPARTAMENTO}>{itemDepartamentosVisita.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="id" value={this.props.match.params.id} />
                                                    <label htmlFor="id_municipio">ID. Municipio</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="id_municipio" id="id_municipio" defaultValue={municipio.ID_MUNICIPIO}
                                                            className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="ID. MUNICIPIO" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el ID. Municipio</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={municipio.NOMBRE}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NOMBRE" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="abreviatura">Abreviatura</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="abreviatura" id="abreviatura" defaultValue={municipio.ABREVIATURA}
                                                        className={((this.verificarError("error_abreviatura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="ABREVIATURA" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Digite la Abreviatura</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN INTERVENTORÍA</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="tarifa_interventoria">Tarifa Interventoría</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="tarifa_interventoria" id="tarifa_interventoria" defaultValue={municipio.TARIFA_INTERVENTORIA}
                                                            className={((this.verificarError("error_tarifa_interventoria")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Tarifa Interventoría" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Tarifa Interventoría</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="CONCEPTO_CALCULO">Concepto Cálculo</label>
                                                    <select name="CONCEPTO_CALCULO"
                                                        id="CONCEPTO_CALCULO"
                                                        value={municipio.CONCEPTO_CALCULO}
                                                        options={municipio.CONCEPTO_CALCULO}
                                                        className={((this.verificarError("error_concepto_calculo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Concepto Cálculo</option>
                                                        <option value="1">VALOR FAVOR</option>
                                                        <option value="2">VALOR RECAUDO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Concepto Cálculo</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN COSTOS (UCAPS)</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="costo_ingenieria">Costo Ingeniería</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="costo_ingenieria" id="costo_ingenieria" defaultValue={municipio.COSTO_INGENIERIA}
                                                            className={((this.verificarError("error_costo_ingenieria")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Ingeniería" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Costo Ingeniería</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="costo_admin_obra">Costo Admin. Obra</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="costo_admin_obra" id="costo_admin_obra" defaultValue={municipio.COSTO_ADMIN_OBRA}
                                                            className={((this.verificarError("error_costo_admin_obra")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Admin. Obra" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Costo Admin. Obra</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="costo_inspector">Costo Inspector</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="costo_inspector" id="costo_inspector" defaultValue={municipio.COSTO_INSPECTOR}
                                                            className={((this.verificarError("error_costo_inspector")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Inspector" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Costo Inspector</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="costo_interventoria">Costo Interventoría</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="costo_interventoria" id="costo_interventoria" defaultValue={municipio.COSTO_INTERVENTORIA}
                                                            className={((this.verificarError("error_costo_interventoria")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Interventoría" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Costo Interventoría</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="costo_financiero">Costo Financiero</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="costo_financiero" id="costo_financiero" defaultValue={municipio.COSTO_FINANCIERO}
                                                            className={((this.verificarError("error_costo_financiero")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Financiero" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Costo Financiero</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Municipio Visita</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterMunicipiosVisita"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;